module.exports = __webpack_public_path__ + "img/thanks.81f269c0.png";